import { inject, Injectable } from "@angular/core";
import { EducationLevelDto, HomophoneGroupDto } from "@clients/squidex/dtos/homophone-group.dto";
import { EducationLevel } from "@domain/EducationLevel";
import { HomophoneGroup } from "@domain/HomophoneGroup";
import { NonEmptyArray } from "@helpers/array.helper";
import { SQUIDEX_CLIENT } from "@squidexClient";

@Injectable({
  providedIn: "root",
})
export class HomophoneGroupClient {
  private client = inject(SQUIDEX_CLIENT);

  async getHomophoneGroups() {
    const data = await this.client.contents.getContents("homophone-groups");

    return data?.items.map(homophoneGroupDto => this.mapToDomain(homophoneGroupDto)) ?? [];
  }

  private mapToDomain(homophoneGroupDto: HomophoneGroupDto): HomophoneGroup {
    const { name: displayName, answers, educationLevel, audioFileName, phonetics, pronunciation, difficulty } = homophoneGroupDto.data;

    return {
      id: homophoneGroupDto.id,
      displayName: displayName.iv,
      suggestedAnswers: answers.iv,
      educationLevels: this.mapEducationLevelsDtoToDomain(educationLevel.iv),
      audioFileName: audioFileName.iv,
      phonetics: phonetics.iv,
      pronunciation: pronunciation.iv,
      difficulty: difficulty.iv,
    };
  }

  private mapEducationLevelsDtoToDomain(educationLevelDtos: NonEmptyArray<EducationLevelDto>): NonEmptyArray<EducationLevel> {
    const dtoToEnumMapping: Record<EducationLevelDto, EducationLevel> = {
      "Primaire 3": EducationLevel.ELEMENTARY_3,
      "Primaire 4": EducationLevel.ELEMENTARY_4,
      "Primaire 5": EducationLevel.ELEMENTARY_5,
      "Primaire 6": EducationLevel.ELEMENTARY_6,
      "Secondaire 1": EducationLevel.HIGH_SCHOOL_1,
      "Secondaire 2": EducationLevel.HIGH_SCHOOL_2,
      "Secondaire 3": EducationLevel.HIGH_SCHOOL_3,
      "Secondaire 4": EducationLevel.HIGH_SCHOOL_4,
      "Secondaire 5": EducationLevel.HIGH_SCHOOL_5,
    };

    return educationLevelDtos.map(educationLevelDto => dtoToEnumMapping[educationLevelDto]) as NonEmptyArray<EducationLevel>;
  }
}
